import axios from 'axios'
export async function GetAllowedFileExtensions () {
  const fileextensions = await axios.get(`${window.apiConfig.APIURL}api/documents/alloweduploadfileextensions`, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
  return fileextensions
}
export function PostDocument (ownerType, ownerId, formdata, category = null) {
  if (!ownerId) {
    return
  }
  const categoryQuery = category ? `?category=${encodeURIComponent(category)}` : ''
  return axios.post(`${window.apiConfig.APIURL}api/documents/${ownerType}/${ownerId}${categoryQuery}`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
      // "Content-Type": "application/json; charset=utf-8",
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
// Portal documents on the user's tasks and sites, without document data
export function GetDocumentListing (filter) {
  return axios.get(`${window.apiConfig.APIURL}api/documents?${documentFilterParams(filter)}`, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
// Sites having documents in the filter's category, with document counts
export function GetDocumentListingSites (filter) {
  return axios.get(`${window.apiConfig.APIURL}api/documents/sites?${documentFilterParams(filter)}`, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
export function GetDocument (id) {
  return axios.get(`${window.apiConfig.APIURL}api/documents/${id}`, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
// Removes a document uploaded in the portal from the portal (internal users). It stays in Mobigo.
export function DeleteDocument (id) {
  return axios.delete(`${window.apiConfig.APIURL}api/documents/${id}`, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
function documentFilterParams ({ category, customerId, objectId, search, orderBy, descending, page, pageSize } = {}) {
  const params = new URLSearchParams()
  if (category) {
    params.append('filter.category', category)
  }
  if (customerId) {
    params.append('filter.customerIds', customerId)
  }
  if (objectId) {
    params.append('filter.objectId', objectId)
  }
  if (search) {
    params.append('filter.search', search)
  }
  if (orderBy) {
    params.append('filter.orderBy', orderBy)
    params.append('filter.descending', Boolean(descending))
  }
  if (page !== undefined) {
    params.append('filter.page', page)
  }
  if (pageSize) {
    params.append('filter.pageSize', pageSize)
  }
  return params.toString()
}
export async function Register (json) {
  return axios.put(`${window.apiConfig.APIURL}api/users`, JSON.stringify(json), {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}
